import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { User } from '../models/user';

/**
 * Route Guard for Reporting V2
 * Allows all account types (Type 1, 2, 3)
 */
export const reportingV2RouteGuard: CanActivateFn = (_route, state) => {
  const router = inject(Router);
  const user = inject(User);

  // Check if user is authenticated
  if (!user.access_token) {
    return router.createUrlTree(['/auth/login'], { queryParams: { redirectUrl: state.url } });
  }

  // Admins can access everything
  if (user.groups.includes('admin')) {
    return true;
  }

  // Check account type
  const accountType = user.primary_organization?.account_type;

  // Type 2 (MSP) and Type 3 (MMSP) can use V2
  if (accountType === 2 || accountType === 3) {
    return true;
  }

  // Type 1 (Direct Customer) can access V2
  if (accountType === 1) {
    return true;
  }

  // Unknown account type - redirect to unauthorized
  return router.createUrlTree(['/customer/unauthorized']);
};
